'use strict'

require 'groupon-gig/src/gig'
